// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"b9936bf8","311":"1c41df6c","925":"6b63d37d"}[chunkId] + ".chunk.css";
};